import React from "react";
import { IconProps } from "..";

export default (props: IconProps) => (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8.141 11a.239.239 0 0 0 .203-.365l-3.106-4.97a1.103 1.103 0 0 1 .093-1.3l2.51-2.972A.239.239 0 0 0 7.658 1H5.703a.239.239 0 0 0-.183.085l-1.866 2.21a2.756 2.756 0 0 0-.232 3.249l2.715 4.344c.044.07.12.112.203.112H8.14z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);
